import React, { useEffect, useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import LazyImage from '../../../../ui-core/Image';
import { improveMob, improveMobWebp } from '../../images';

import './style.css';
import { TEXT_CONSTANT } from '../../../../constants/app';
import {
  addAosAnimateClassObserver,
  formatCurrency,
} from '../../../../utils/helpers';
import Button from '../../../../ui-core/Button/Button';

export const JoinMobility = props => {
  const { isLoading, courseDetail, currentPrice } = props;
  const handleClick = () => {
    if (props.onClick) {
      props.onClick(
        TEXT_CONSTANT.JOIN_NOW,
        'isSignup',
        'Join Us Now & Receive!',
      );
    }
  };
  const elementRef = useRef();
  const leftSectionRef = useRef();
  const rightSectionRef = useRef();
  const bottomSectionRef = useRef();
  useEffect(() => {
    const observer = addAosAnimateClassObserver();
    if (elementRef?.current) {
      observer.observe(elementRef.current);
    }
    if (leftSectionRef?.current) {
      observer.observe(leftSectionRef.current);
    }
    if (rightSectionRef?.current) {
      observer.observe(rightSectionRef.current);
    }
    if (bottomSectionRef?.current) {
      observer.observe(bottomSectionRef.current);
    }

    return () => {
      elementRef?.current && observer.unobserve(elementRef?.current);
      leftSectionRef?.current && observer.unobserve(leftSectionRef?.current);
      rightSectionRef?.current && observer.unobserve(rightSectionRef?.current);
      bottomSectionRef?.current &&
        observer.unobserve(bottomSectionRef?.current);
    };
  }, [
    elementRef?.current,
    leftSectionRef?.current,
    rightSectionRef?.current,
    bottomSectionRef?.current,
  ]);
  return (
    <div
      ref={elementRef}
      className="join-us"
      data-aos="fade-in"
      data-aos-delay="50"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
    >
      <h2>
        Join Us <em>Now</em> & Receive!
      </h2>
      <Row>
        <Col
          ref={leftSectionRef}
          lg="4"
          className="order-2"
          data-aos="fade-left"
          data-aos-delay="50"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
        >
          <ul>
            <li>30 Structured Days of Mobility</li>
            <li>9 Self-Assessments to assess and reassess progress</li>
            <li>28 Guided Mobility Videos ranging from 3-8 minutes</li>
          </ul>
        </Col>
        <Col lg="4" className="order-sm-1">
          <div className="join-us-img position-relative">
            <LazyImage
              errorSrc={improveMob}
              placeholderSrc={improveMobWebp}
              src={improveMobWebp}
              className="w-100 img-fluid position-relative"
            />
          </div>
        </Col>
        <Col
          ref={rightSectionRef}
          lg="4"
          data-aos="fade-right"
          data-aos-delay="50"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
        >
          <ul>
            <li>Workbook to Note & Track Progress</li>
            <li>Weekly Private Webinars for further support & education</li>
            <li>Tracking, Accountability, and Community Support</li>
          </ul>
        </Col>
      </Row>
      <div
        ref={bottomSectionRef}
        data-aos="fade-up"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
      >
        {' '}
        {/* <div className="excite-offer">
          Starting Sunday, November 5th to receive exciting prizes!
        </div> */}
        <br />
        <Button
          type="button"
          isLoading={isLoading}
          class="site-btn-stroke mx-auto hover-white"
          onClick={handleClick}
          disabled={isLoading}
          text={`Join now at ${formatCurrency(
            currentPrice,
            courseDetail?.attributes?.currency,
            2,
          )}`}
        />
      </div>

      <div className="strip">
        <ul>
          <li>Improve Mobility</li>
          <li>Join Now</li>
          <li>Mobility Foundation</li>
          <li>Improve Mobility</li>
          <li>Join Now</li>
          <li>Mobility Foundation</li>
          <li>Improve Mobility</li>
        </ul>

        <ul className="two">
          <li>Improve Mobility</li>
          <li>Join Now</li>
          <li>Mobility Foundation</li>
          <li>Improve Mobility</li>
          <li>Join Now</li>
          <li>Mobility Foundation</li>
          <li>Improve Mobility</li>
          <li>Join Now</li>
        </ul>
      </div>
    </div>
  );
};

JoinMobility.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  courseDetail: PropTypes.object,
  currentPrice: PropTypes.number,
};
